'use strict';

exports.__esModule = true;
exports.widget = undefined;

var _assign = require('babel-runtime/core-js/object/assign');

var _assign2 = _interopRequireDefault(_assign);

var _widgetActions = require('../actions/widget-actions');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var babelPluginFlowReactPropTypes_proptype_Action = require('../actions/widget-actions').babelPluginFlowReactPropTypes_proptype_Action || require('react').PropTypes.any;

if (typeof exports !== 'undefined') Object.defineProperty(exports, 'babelPluginFlowReactPropTypes_proptype_Widget', {
  value: require('react').PropTypes.shape({
    isGroup: require('react').PropTypes.bool.isRequired,
    baseUrl: require('react').PropTypes.string.isRequired,
    profileId: require('react').PropTypes.string.isRequired,
    profileType: require('react').PropTypes.string.isRequired,
    link: require('react').PropTypes.string.isRequired,
    totalReviews: require('react').PropTypes.number.isRequired,
    averageRating: require('react').PropTypes.number.isRequired
  })
});


var INITIAL_STATE = {
  isGroup: false,
  baseUrl: '',
  profileId: '',
  profileType: '',
  link: '',
  totalReviews: 0,
  averageRating: 0
};

var widget = exports.widget = function widget() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : INITIAL_STATE;
  var action = arguments[1];

  switch (action.type) {
    case _widgetActions.UPDATE_WIDGET_DETAILS:
      return (0, _assign2.default)({}, state, {
        isGroup: action.payload.isGroup,
        baseUrl: action.payload.baseUrl,
        profileId: action.payload.profileId,
        profileType: action.payload.profileType,
        link: action.payload.link
      });
    case _widgetActions.LOAD_SINGLE_PROFILE_REVIEWS + '_RECEIVED':
      return (0, _assign2.default)({}, state, {
        totalReviews: action.response.total_reviews,
        averageRating: action.response.average_rating
      });
    case _widgetActions.LOAD_ALL_PRACTICES_REVIEWS_COUNT + '_RECEIVED':
      return (0, _assign2.default)({}, state, {
        totalReviews: action.response.count
      });
    case _widgetActions.LOAD_ALL_PRACTICES_REVIEWS + '_RECEIVED':
      return (0, _assign2.default)({}, state, {
        averageRating: action.response.aggregate_review
      });
    default:
      return state || INITIAL_STATE;
  }
};